import { render, staticRenderFns } from "./btn-email.vue?vue&type=template&id=d8d0fbb8"
import script from "./btn-email.vue?vue&type=script&lang=js"
export * from "./btn-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports